// src/services/changelog.js
import config from '../config/env';

export async function getAllChangelogEvents() {
  try {
    const response = await fetch(`${config.API_URL}/api/deltaops/changelog/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'demo_user'
      }
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching all changelog events:', error);
    throw error;
  }
}

export async function searchChangelogEvents(description, topK=5) {
  try {
    const response = await fetch(`${config.API_URL}/api/deltaops/changelog/search/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': 'demo_user'
      },
      body: JSON.stringify({
        query: description,
        top_k: topK
      })
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    return await response.json();
  } catch (error) {
    console.error('Error searching changelog events:', error);
    throw error;
  }
}